module.exports = __webpack_public_path__ + "media/images/customer_area/sprite-31dbebff3476dbc944fccb93576c7a08.svg";